import { resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_view = _resolveComponent("router-view")!
  const _component_AuthCodeModal = _resolveComponent("AuthCodeModal")!
  const _component_CompanyExpressDataModal = _resolveComponent("CompanyExpressDataModal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", {
      style: _normalizeStyle([_ctx.style, {"height":"100%","background-size":"cover"}]),
      class: "d-flex flex-column flex-root"
    }, [
      _createVNode(_component_router_view),
      _createVNode(_component_AuthCodeModal)
    ], 4),
    _createVNode(_component_CompanyExpressDataModal)
  ], 64))
}